import React, {useCallback, useEffect, useState} from 'react';
import WorkspaceService from "./WorkspaceService";
import AuthenticationService from "../authentication/AuthenticationService";
import {applyMechanicalSettingsOverrides} from "../../business/measurement/WentechMeasurementStandards";

export const WorkspaceContext = React.createContext();

export default function WorkspaceContextProvider({children}) {

    const [workspaceData, setWorkspaceData] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    const setWorkspaceDataxx = d => {
        setWorkspaceData(wd => {
            return {...wd, ...d}; // Note workspaceData cannot be used, becasue we build state based on current state (workspaceData may be outdated)
        });
    }

    const contextValue = {
        data: workspaceData,
        applyNewData: setWorkspaceDataxx
    };

    const reloadWorkspaceData = useCallback(() => {
        const authStatus = AuthenticationService.getCurrentAuthStatus();

        if (!authStatus.authenticated || !authStatus.authenticationStatusKnown) {
            console.log("Skipping workspace data fetch - user not authenticated");
            setWorkspaceData({});
            setIsLoading(false);
            return;
        }

        console.log("Refetching workspace data");
        setWorkspaceData({});
        setIsLoading(true);
        WorkspaceService.getWorkspaceData().then(workspaceData => {
            if (workspaceData.mechanicalSettings) {
                applyMechanicalSettingsOverrides(workspaceData.mechanicalSettings);
            }
            setWorkspaceDataxx(workspaceData);
            setIsLoading(false);
        });
    }, []);

    useEffect(() => {
        reloadWorkspaceData();
        AuthenticationService.addAuthStatusChangeListener(function (newKnownAuthStatus) {
            reloadWorkspaceData();
        });
    }, [reloadWorkspaceData]);

    if (isLoading) {
        return <div>Loading workspace...</div>;
    }

    return <WorkspaceContext.Provider value={contextValue}>
        {children}
    </WorkspaceContext.Provider>;
}
